export const selectAuthUser = state => {
  return state.auth.user;
};
export const selectIsAuthorizing = state => {
  return state.auth.isAuthorizing;
};
export const selectChatToken = state => {
  return state.auth.chatToken;
};
export const selectBankAccounts = state => {
  return state.auth.bankAccounts;
};
export const selectCreditCards = state => {
  return state.auth.creditCards;
};
export const selectIsFetchingCreditCards = state => {
  return state.auth.isFetchingCreditCards;
};
export const selectNotificationsCount = state => {
  return state.auth.notificationCount;
};
export const selectCountryList = state => {
  return state.auth.countryList;
};


export const selectStateList = state => {
  return state.auth.usaStates;
};
